import React, { useEffect, useState, useRef } from "react";
import HeaderData from "../HeaderData";
import TabSelector from "../TabSelector";
import { getUpdateDate } from "../utils/monthNames";
import OTCobrosPorFormularTable from "./OTCobrosPorFormularTable";
import Select from "react-select";
import { SingleOption, customStylesPedidos, parseDate, parseBudat } from "../utils/utils";
import DatePicker from "react-datepicker";
import PrintComponent from "../PrintComponent";
import ExportExcel from "../ExportExcel";
import { getPaginationItems, openBase64NewTab, setInstalalaciones, setPagadoresArcoprime } from "../utils/get";
import MantenimientoCard from "./MantenimientoCard";
import Pagination from "react-js-pagination";
import MantenimientoResponsiveCard from "./MantenimientoResponsiveCard";
import { hideGreyBackground, showGreyBackground } from "../utils/windows";
import MantenimientoModal from "./MantenimientoModal";
import SearchFilter from "../../assets/img/filter-avisos-mantencion.svg";
import OrdenarAvisosMantenimientoModal from "./OrdenarAvisosMantenimientoModal";
import OpcionesOrdenamientoModalModal from "./OpcionesOrdenamientoModal";

const OTCobrosPorFormular = ({
  rutConcesionario,
  token,
  pagador,
  cabecera,
  instalaciones,
  isROImpersonate,
  edsPortal,
  callServiceHandler
}) => {
  const [updateDate, setUpdateDate] = useState();
  const [selectedTab, setSelectedTab] = useState(1);
  const [allEds, setAllEds] = useState([]);
  const [selectedEds, setSelectedEds] = useState();
  const [fechaDesde, setFechaDesde] = useState();
  const [fechaHasta, setFechaHasta] = useState();
  const [filterText, setFilterText] = useState("");
  const tableRef = useRef(null);
  const [ordenValue, setOrdenValue] = useState("");
  const [orden, setOrden] = useState();

  const [ordenes, setOrdenes] = useState();
  const [ordenesOriginal, setOrdenesOriginal] = useState(); // snapshot para Restablecer Orden

  const [filteredOrdenes, setFilteredOrdenes] = useState();
  const [paginationActivePage, setPaginationActivePage] = useState(1);
  const [paginationFilteredOrdenes, setPaginationFilteredOrdenes] = useState([]);
  const paginationItemsPerPage = parseInt(process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE);

  const [distanceToTop, setDistanceToTop] = useState(0);

  // Arcoprime
  const [isArcoprime, setIsArcoprime] = useState(false);
  const [allPagadores, setAllPagadores] = useState([]);
  const [selectedPagador, setSelectedPagador] = useState();

  const [displayOrdenModal, setDisplayOrdenModal] = useState(false);
  const [ordenModal, setOrdenModal] = useState({});

  const [displayOrdenarAvisosMantenimientoModal, setDisplayOrdenarAvisosMantenimientoModal] = useState(false);
  const [displayOpcionesOrdenamientoModal, setDisplayOpcionesOrdenamientoModal] = useState(false);
  const [optionsModalTitle, setOptionsModalTitle] = useState("");

  const [nroOrdenFilterValue, setNroOrdenFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [fechaOrdenFilterValue, setFechaOrdenFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [estadoFilterValue, setEstadoFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });
  const [montoPlanFilterValue, setMontoPlanFilterValue] = useState({ label: "Seleccionar", value: "seleccionar" });

  const [distanceToTopOrdenarAvisosMantenimientoModal, setDistanceToTopOrdenarAvisosMantenimientoModal] = useState(0);

  const [openedCards, setOpenedCards] = useState(0);

  const [extraPadding, setExtraPadding] = useState(0);

  const labels = [
    ["Nº de Orden", "NUMERO_ORDEN"],
    ["Fecha de Orden", "FECHA_ORDEN"],
    ["Fecha de Cierre", "FECHA_CIERRE"],
    ["Estado", "ESTADO"],
    ["Monto Plan", "MONTO_PLAN"],
    ["Monto Real", "MONTO_REAL"],
    ["Descripción", "DESCRIPCION"],
    ["Factura", "FACTURA"],
  ];

  const openOrdenarAvisosMantenimientoModal = (e) => {
    showGreyBackground();
    
    setDistanceToTopOrdenarAvisosMantenimientoModal(e.currentTarget.getBoundingClientRect().top);
    setDisplayOrdenarAvisosMantenimientoModal(true);
  };

  const openOpcionesOrdenamientoModal = () => {
    setDisplayOpcionesOrdenamientoModal(true);
    showGreyBackground();
  };

  const closeOpcionesOrdenamientoModal = () => {
    setDisplayOpcionesOrdenamientoModal(false);
    hideGreyBackground();
  };

  const closeOrdenarAvisosMantenimientoModal = () => {
    setDisplayOrdenarAvisosMantenimientoModal(false);
    hideGreyBackground();
  };

  const isSelected = (opt) => opt && opt.value && opt.value !== "seleccionar";

  const parseDDMMYYYYToDate = (ddmmyyyy) => {
    if (!ddmmyyyy || typeof ddmmyyyy !== "string") return null;
    const parts = ddmmyyyy.split("/");
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts.map((x) => parseInt(x, 10));
    if (!dd || !mm || !yyyy) return null;
    return new Date(yyyy, mm - 1, dd);
  };

  const compareStrings = (a, b) => {
    const sa = (a ?? "").toString();
    const sb = (b ?? "").toString();
    // numeric:true ayuda con strings con números (y mantiene bien ceros a la izquierda)
    return sa.localeCompare(sb, "es", { numeric: true, sensitivity: "base" });
  };

  const applyTextFilter = (arr, text) => {
    let data = arr;

    if (text && data?.length > 0) {
      const filterTextLower = text.toLowerCase().replaceAll(".", "");

      const fieldsToSearch = [
        "NUMERO_ORDEN",
        "FECHA_ORDEN",
        "FECHA_CIERRE",
        "ESTADO",
        "MONTO_PLAN",
        "MONTO_REAL",
        "DESCRIPCION",
        "FACTURA",
      ];

      data = data.filter((orden) =>
        fieldsToSearch.some((field) => {
          const val = orden?.[field];
          if (val === null || typeof val === "undefined") return false;
          return String(val).toLowerCase().includes(filterTextLower);
        })
      );
    }

    return data;
  };

  // Helpers (sácalos fuera del componente si puedes; si no, déjalos encima de buildComparator)
  // Mantiene responsabilidad de comparación separada para bajar la complejidad de buildComparator.

  const invertByDir = (dir) => (dir === "DESC" || dir === "Z_A" ? -1 : 1);

  const compareDateDDMMYYYY = (aVal, bVal) => {
    const ta = parseDDMMYYYYToDate(aVal)?.getTime?.() ?? 0;
    const tb = parseDDMMYYYYToDate(bVal)?.getTime?.() ?? 0;
  
    if (ta === tb) return 0;
    if (ta > tb) return 1;
    return -1;
  };

  const compareNumber = (aVal, bVal) => {
    const na = Number(aVal ?? 0);
    const nb = Number(bVal ?? 0);
  
    if (na === nb) return 0;
    if (na > nb) return 1;
    return -1;
  };
  

  const compareValueByType = (type, a, b, key) => {
    const av = a?.[key];
    const bv = b?.[key];

    switch (type) {
      case "date":
        return compareDateDDMMYYYY(av, bv);
      case "number":
        return compareNumber(av, bv);
      case "string":
      default:
        return compareStrings(av, bv);
    }
  };

  const makeCriteriaFromDefs = (defs, isSelectedFn) =>
    defs
      .filter((d) => isSelectedFn(d.selected))
      .map((d) => ({
        key: d.key,
        type: d.type,
        factor: invertByDir(d.selected.value), // -1 si DESC/Z_A, 1 si no
      }));

  const applyCriteriaCompare = (criteria, a, b) => {
    for (let i = 0; i < criteria.length; i++) {
      const { key, type, factor } = criteria[i];
      const res = compareValueByType(type, a, b, key);
      if (res !== 0) return res * factor;
    }
    return 0;
  };

  // --------------------------------------------
  // buildComparator (queda bien corto y baja complejidad)
  // --------------------------------------------
  const buildComparator = () => {
    const defs = [
      { selected: nroOrdenFilterValue, key: "NUMERO_ORDEN", type: "string" }, // ASC/DESC
      { selected: fechaOrdenFilterValue, key: "FECHA_ORDEN", type: "date" },  // ASC/DESC
      { selected: estadoFilterValue, key: "ESTADO", type: "string" },         // A_Z/Z_A
      { selected: montoPlanFilterValue, key: "MONTO_PLAN", type: "number" },  // ASC/DESC
    ];

    const criteria = makeCriteriaFromDefs(defs, isSelected);
    if (criteria.length === 0) return null;

    return (a, b) => applyCriteriaCompare(criteria, a, b);
  };

  
  const applyOrdenamiento = () => {
    if (!Array.isArray(ordenes) || ordenes.length === 0) return;
  
    const comparator = buildComparator();
    if (!comparator) {
      // Si no hay criterios seleccionados, no hacemos nada (mantiene el orden actual)
      closeOrdenarAvisosMantenimientoModal();
      return;
    }
  
    // Ordenamos base completa (para que el orden persista aunque cambie el texto del buscador)
    const sortedBase = [...ordenes].sort(comparator);
  
    // Actualizamos base ordenada
    setOrdenes(sortedBase);
  
    // Y luego aplicamos el filtro de texto sobre la base ordenada
    const filtered = applyTextFilter(sortedBase, filterText);
    setFilteredOrdenes(filtered);
  
    if (Array.isArray(filtered) && filtered.length > 0) {
      getPaginationItems(filtered, 1, setPaginationFilteredOrdenes, setPaginationActivePage);
    } else {
      setPaginationFilteredOrdenes([]);
      setPaginationActivePage(1);
    }
  
    closeOrdenarAvisosMantenimientoModal();
  };
  

  const restoreOrdenOriginal = () => {
    if (!ordenesOriginal?.length) return;

    const restoredBase = ordenesOriginal.map((o) => ({ ...o }));
    restoredBase["vacio"] = false;

    setOrdenes(restoredBase);

    const filtered = applyTextFilter(restoredBase, filterText);
    setFilteredOrdenes(filtered);

    if (filtered?.length > 0) {
      getPaginationItems(filtered, 1, setPaginationFilteredOrdenes, setPaginationActivePage);
    } else {
      setPaginationFilteredOrdenes([]);
      setPaginationActivePage(1);
    }
  };

  const handleOrdenarClick = () => {
    applyOrdenamiento();
  };

  const handleRestablecerOrden = () => {
    // El modal ya resetea selects; acá restauramos la data al orden original
    restoreOrdenOriginal();
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== "dev") {
      if (token && rutConcesionario) {
        getUpdateDate(setUpdateDate);
        if (rutConcesionario === "77215640-5") {
          setIsArcoprime(true);
        }
      }
    } else {
      if (token) {
        getUpdateDate(setUpdateDate);
        if (rutConcesionario === "77215640-5" /* || true */) {
          setIsArcoprime(true);
        }
      }
    }
  }, [token, rutConcesionario]);

  useEffect(() => {
    if (instalaciones !== "") {
      if (!isArcoprime) {
        setInstalalaciones(instalaciones, setAllEds);
      }
    }
  }, [instalaciones]);

  useEffect(() => {
    if (edsPortal) {
      setPagadoresArcoprime(edsPortal.data.user_eds, setAllPagadores);
    }
  }, [edsPortal]);

  useEffect(() => {
    if (allPagadores.length === 1) {
      changePagador(allPagadores[0]);
    }
  }, [allPagadores]);

  function changePagador(e) {
    setSelectedPagador(e);
  }

  useEffect(async () => {
    if (selectedPagador) {
      const url =
        process.env.REACT_APP_PEDIDOS_API +
        "/pedidos/obtener-instalaciones-cliente?id_pagador=" +
        selectedPagador.value;

      let result = await callServiceHandler(url, "GET");
      if (result !== "error") {
        setInstalalaciones(result.data, setAllEds);
      }
    }
  }, [selectedPagador]);

  useEffect(() => {
    if (allEds) {
      changeEds(allEds[0]);
    }
  }, [allEds]);

  function closeModal() {
    setDisplayOrdenModal(false);
    hideGreyBackground();
  }

  function reset() {
    setOrden();
    setFechaDesde();
    setFechaHasta();
    setOrdenes();
    setOrdenesOriginal();
    setFilteredOrdenes();
    setPaginationFilteredOrdenes([]);
    setPaginationActivePage(1);
    setOrdenValue("");

    // Reset filtros de ordenamiento al cambiar contexto (EDS / fechas)
    setOptionsModalTitle("");
    setNroOrdenFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setFechaOrdenFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setEstadoFilterValue({ label: "Seleccionar", value: "seleccionar" });
    setMontoPlanFilterValue({ label: "Seleccionar", value: "seleccionar" });
  }

  async function changeEds(e) {
    reset();
    setSelectedEds(e);
  }

  function handleOrderEnter(e) {
    if (e.key === "Enter") {
      getOrden(ordenValue);
    }
  }

  async function getOrden(numeroOrden) {
    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-ordenes?rut_concesionario=" +
      rutConcesionario +
      "&id_eds=" +
      selectedEds.value +
      "&orden=" +
      numeroOrden;

    let result = await callServiceHandler(url, "GET");
    console.log("AVISOO", result);
    if (result !== "error") {
      if (result.data.ORDENES.length === 0) {
        setOrden({ vacio: true });
      } else {
        const dataFinal = result.data.ORDENES[0];
        dataFinal["vacio"] = false;
        setOrden(dataFinal);
      }
    }
  }

  useEffect(() => {
    if (fechaHasta) {
      getOrdenes();
    }
  }, [fechaHasta]);

  useEffect(() => {
    setFilteredOrdenes(ordenes);
    if (ordenes?.length > 0) {
      getPaginationItems(ordenes, 1, setPaginationFilteredOrdenes, setPaginationActivePage);
    }
  }, [ordenes]);

  function handlePageChange(pageNumber) {
    getPaginationItems(filteredOrdenes, pageNumber, setPaginationFilteredOrdenes, setPaginationActivePage);
  }

  useEffect(() => {
    if (filteredOrdenes?.length > 0) {
      console.log("FILTERED ORDENES", filteredOrdenes);
    }
  }, [filteredOrdenes]);

  async function getOrdenes() {
    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-ordenes?rut_concesionario=" +
      rutConcesionario +
      "&id_eds=" +
      selectedEds.value +
      "&fecha_desde=" +
      parseDate(fechaDesde) +
      "&fecha_hasta=" +
      parseDate(fechaHasta);
  
    let result = await callServiceHandler(url, "GET");
   
    console.log(result);
  
    if (result !== "error") {
      if (result.data.ORDENES.length === 0) {
        setOrdenes([]);
        setOrdenesOriginal([]);
        setFilteredOrdenes([]);
        setPaginationFilteredOrdenes([]);
        setPaginationActivePage(1);
        // si necesitas el flag para render:
        // setOrdenesVacio(true);
      } else {
        const dataFinal = cleanOrdenes(result.data.ORDENES);
  
        // Base
        setOrdenes(dataFinal);
  
        // Snapshot original para Restablecer Orden
        const snapshot = dataFinal.map((o) => ({ ...o }));
        setOrdenesOriginal(snapshot);
  
        // si necesitas el flag para render:
        // setOrdenesVacio(false);
  
        console.log("ORDENES", dataFinal);
      }
    }
  }
  

  function cleanOrdenes(ordenesdata) {
    const newOrdenes = [];

    console.log("ORDENES DATA", ordenesdata);

    ordenesdata.map((orden) => {
      const newOrden = {
        NUMERO_ORDEN: orden.numero_orden,
        FECHA_ORDEN: parseBudat(orden.fecha_orden),
        FECHA_CIERRE: orden.fecha_cierre !== "0000-00-00" ? parseBudat(orden.fecha_cierre) : "En Progreso",
        DESCRIPCION: orden.descripcion,
        FACTURA: orden.factura ? orden.factura : " ",
        TIENE_ADJUNTOS: orden.tiene_adjuntos,
        ADJUNTOS: orden.ADJUNTOS,
        MONTO_PLAN: orden.monto_plan,
        MONTO_REAL: orden.monto_real,
        ESTADO: orden.estado,
        URL: orden.url
      };
      newOrdenes.push(newOrden);
    });

    return newOrdenes;
  }

  function changeFechaDesde(e) {
    setFechaDesde(e);
    setFechaHasta();
  }

  function changeFechaHasta(e) {
    setFechaHasta(e);
  }

  async function openFile(adjunto) {
    console.log("ADJUNTO:", adjunto);

    let url =
      process.env.REACT_APP_MANTENIMIENTO_API +
      "/mantenimiento/obtener-adjunto?id_sap=" +
      adjunto.id_sap;

    let result = await callServiceHandler(url, "GET");
    console.log(result);
    if (result.data.error === true) {
      return true;
    } else {
      openBase64NewTab(result.data.body, result.data.tipo);
    }
  }

  function getMaxDate(fechaD) {
    const now = new Date();
    const minMasUno = new Date(fechaD?.getFullYear() + 1, fechaD?.getMonth(), fechaD?.getDate());

    if (now > minMasUno) {
      return minMasUno;
    } else {
      return now;
    }
  }

  useEffect(() => {
    // Filtrado por texto se aplica sobre la base actual (ordenes),
    // para que el ordenamiento persista cuando cambie el buscador.
    const filtered = applyTextFilter(ordenes, filterText);
    setFilteredOrdenes(filtered);

    if (filtered?.length > 0) {
      getPaginationItems(filtered, 1, setPaginationFilteredOrdenes, setPaginationActivePage);
    } else {
      setPaginationFilteredOrdenes([]);
      setPaginationActivePage(1);
    }
  }, [filterText]);

  const getExtraPadding = () => {
    let aux = 0;
    if (!(window.innerWidth < 1023)){
      setExtraPadding(aux);
      return aux;
    }

    if (displayOrdenModal) {
      aux = ((openedCards * 305) + 410);
    }else{
      aux = (openedCards * 305);
    }
    setExtraPadding(aux);
    return aux;
  }
  
  useEffect(() => {
    getExtraPadding();
  }, [displayOrdenModal, openedCards]);

  return (
    <div className="pedidos-activos page">
      <div className="view-title">Mantenimiento</div>
      <div className="view-title-separator">|</div>
      <div className="view-subtitle">OT Cobros por Formular</div>
      <hr className="title-separator-line header-data-avisos-mantenimiento-separator" />
      <div className="header-data-avisos-mantenimiento-container">
        <HeaderData
          rutConcesionario={rutConcesionario}
          token={token}
          actualizacion={updateDate}
          cabecera={cabecera}
          callServiceHandler={callServiceHandler}
        />
      </div>

      <TabSelector
        tab1="Buscar por Nº Orden"
        tab2="Buscar por Fecha"
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        reset={reset}
      />

      {selectedTab === 1 && (
        <div className="order-container">
          <div className="order-options">
            <div className="filters-container">
              {isArcoprime && (
                <div className={`filter`}>
                  <div className="filter-title required-field">ID DE PAGADOR</div>
                  <div className="filter-input">
                    <Select
                      className="eds-select"
                      value={selectedPagador}
                      onChange={(e) => changePagador(e)}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      options={allPagadores}
                      components={{
                        SingleOption,
                        IndicatorSeparator: () => null,
                      }}
                      isClearable={false}
                      autosize={false}
                      placeholder="Seleccionar"
                      styles={customStylesPedidos}
                    />
                  </div>
                </div>
              )}
              <div className={`filter ${isArcoprime && "mleft"}`}>
                <div className="filter-title required-field">ESTACIÓN DE SERVICIO</div>
                <div className="filter-input">
                  <Select
                    className="eds-select"
                    value={selectedEds}
                    onChange={(e) => changeEds(e)}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={allEds}
                    components={{
                      SingleOption,
                      IndicatorSeparator: () => null,
                    }}
                    isClearable={false}
                    autosize={false}
                    placeholder="Seleccionar"
                    styles={customStylesPedidos}
                    width="100%"
                  />
                </div>
              </div>
              <div className="filter mleft">
                <div className="filter-title required-field">NÚMERO DE ORDEN</div>
                <div className="filter-input">
                  <input
                    type="text"
                    className="orden-input"
                    id="orden-input"
                    placeholder="Ej: 546465464"
                    value={ordenValue}
                    onChange={(e) => setOrdenValue(e.target.value)}
                    onKeyDown={handleOrderEnter}
                  ></input>
                </div>
              </div>
            </div>
          </div>
          <div className="order-separator"></div>

          {orden && (
            <>
              {orden.vacio ? (
                <div className="order-data">
                  <div className="important-message error">
                    <span className="error-icon">!</span>
                    <span>No existen datos para este Nº de orden.</span>
                  </div>
                </div>
              ) : (
                <>
                  <MantenimientoCard orden={orden} openFile={openFile} tipo="ordenOT" />
                  <div className="order-container">
                    <hr className="orden-separator"></hr>
                    <div className="important-message">
                      <span className="title">Importante:&nbsp;</span>
                      <span>
                        Mientras la OT no se encuentre <span className="aceptada">"Aceptada"</span> el monto real podría cambiar.
                      </span>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}

      {selectedTab === 2 && (
        <>
          <div className="fecha-options ot-cobros-por-formular">
            <div className="filters-container">
              {isArcoprime && (
                <div className={`filter`}>
                  <div className="filter-title required-field">ID DE PAGADOR</div>
                  <div className="filter-input">
                    <Select
                      className="eds-select"
                      value={selectedPagador}
                      onChange={(e) => changePagador(e)}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      options={allPagadores}
                      components={{
                        SingleOption,
                        IndicatorSeparator: () => null,
                      }}
                      isClearable={false}
                      autosize={false}
                      placeholder="Seleccionar"
                      styles={customStylesPedidos}
                    />
                  </div>
                </div>
              )}
              <div className={`filter ${isArcoprime && "mleft"}`}>
                <div className="filter-title required-field">ESTACIÓN DE SERVICIO</div>
                <div className="filter-input">
                  <Select
                    className="eds-select"
                    value={selectedEds}
                    onChange={(e) => changeEds(e)}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={allEds}
                    components={{
                      SingleOption,
                      IndicatorSeparator: () => null,
                    }}
                    isClearable={false}
                    autosize={false}
                    placeholder="Seleccionar"
                    styles={customStylesPedidos}
                    width="100%"
                  />
                </div>
              </div>

              <div className="filter only-tablet-search-input">
                <div className="filter-input search-input">
                  <input
                    type="search"
                    className="search"
                    value={filterText}
                    placeholder="Buscar..."
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                  <img src={SearchFilter} alt="" className="search-filter-icon" />
                </div>
              </div>

              <div className="filter mleft">
                <div className="filter-title required-field">FECHA DESDE</div>
                <div className="filter-input">
                  <DatePicker
                    className="ot-cobros-por-formular-date-picker"
                    locale="es"
                    selected={fechaDesde}
                    onChange={(e) => changeFechaDesde(e)}
                    shouldCloseOnSelect={true}
                    dateFormat="dd/MM/yyyy"
                    maxDate={new Date()}
                    placeholderText="Seleccionar"
                  />
                </div>
              </div>

              <div className="filter mleft">
                <div className="filter-title required-field">FECHA HASTA</div>
                <div className="filter-input">
                  <DatePicker
                    className="ot-cobros-por-formular-date-picker"
                    locale="es"
                    selected={fechaHasta}
                    onChange={(e) => changeFechaHasta(e)}
                    shouldCloseOnSelect={true}
                    dateFormat="dd/MM/yyyy"
                    maxDate={getMaxDate(fechaDesde)}
                    minDate={fechaDesde}
                    placeholderText="Seleccionar"
                    disabled={fechaDesde ? false : true}
                  />
                </div>
              </div>

              <div className="important-message important-message-ot-cobros-por-formular-mobile">
                <span className="title">Importante:&nbsp;</span>
                <span>Mientras la OT no se encuentre <b>"Aceptada"</b> el monto real podría cambiar.</span>
              </div>

              <div className="filter not-tablet-search-input">
                <div className="filter-input search-input">
                  <input
                    type="search"
                    className="search"
                    value={filterText}
                    placeholder="Buscar..."
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                  <img onClick={openOrdenarAvisosMantenimientoModal} src={SearchFilter} alt="" className="search-filter-icon" />
                </div>
              </div>
            </div>

            <div className="actions">
              <PrintComponent
                reff={tableRef}
                pageStyle="@page { size: auto; margin: 3mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 0px !important; } }"
                isROImpersonate={isROImpersonate}
              />

              <ExportExcel data={filteredOrdenes} labels={labels} isROImpersonate={isROImpersonate} />
            </div>
          </div>

          <div className="important-message important-message-ot-cobros-por-formular-not-mobile">
            <span className="title">Importante:&nbsp;</span>
            <span>Mientras la OT no se encuentre <b>"Aceptada"</b> el monto real podría cambiar.</span>
          </div>

          <div className="options-separator"></div>

          
          {filteredOrdenes?.length > 0 ? (
            <div className="mantenimiento-responsive-cards-container" style={{ paddingBottom: `${extraPadding}px` }}>
              {
                filteredOrdenes.map((aviso, key) => {
                  return (
                    <MantenimientoResponsiveCard
                      key={aviso.NUMERO_ORDEN.substring(4)}
                      isOrden={true}
                      aviso={aviso}
                      openFile={openFile}
                      setDisplayAvisoResponsiveModal={setDisplayOrdenModal}
                      setOrdenResponsiveModal={setOrdenModal}
                      setDistanceToTopResponsiveModal={setDistanceToTop}
                      setOpenedCards={setOpenedCards}
                      openedCards={openedCards}
                    />
                  );
                })
              }
            </div>
          ) : (
            <div className="no-orders-container">Selecciona un rango de fechas</div>
          )}

          <OTCobrosPorFormularTable
            tableRef={tableRef}
            ordenes={ordenes}
            filteredOrdenes={filteredOrdenes}
            setFilteredOrdenes={setFilteredOrdenes}
            filterText={filterText}
            paginationFilteredOrdenes={paginationFilteredOrdenes}
            setPaginationActivePage={setPaginationActivePage}
            setPaginationFilteredOrdenes={setPaginationFilteredOrdenes}
            openFile={openFile}
            setDistanceToTop={setDistanceToTop}
            setDisplayOrdenModal={setDisplayOrdenModal}
            setOrdenModal={setOrdenModal}
          />

          <>
            {filteredOrdenes?.length > 0 ? (
              <div className="pagination-container ot-cobros-por-formular-pagination">
                <Pagination
                  activePage={paginationActivePage}
                  itemsCountPerPage={parseInt(paginationItemsPerPage)}
                  totalItemsCount={filteredOrdenes?.length}
                  pageRangeDisplayed={5}
                  onChange={(e) => handlePageChange(e)}
                  hideFirstLastPages={true}
                  linkClassPrev="prev"
                  linkClassNext="next"
                  prevPageText=""
                  nextPageText=""
                />
              </div>
            ) : (
              <></>
            )}
          </>
        </>
      )}

      <div className="modal-container">
        <MantenimientoModal
          displayModal={displayOrdenModal}
          closeModal={closeModal}
          distanceToTop={distanceToTop}
          orden={ordenModal}
          tipo="orden"
          openFile={openFile}
        />
      </div>

      <OrdenarAvisosMantenimientoModal
        displayModal={displayOrdenarAvisosMantenimientoModal}
        setDisplayModal={setDisplayOrdenarAvisosMantenimientoModal}
        closeModal={closeOrdenarAvisosMantenimientoModal}
        distanceToTop={distanceToTopOrdenarAvisosMantenimientoModal}
        setOptionsModalTitle={setOptionsModalTitle}
        setNroOrdenFilterValue={setNroOrdenFilterValue}
        setFechaOrdenFilterValue={setFechaOrdenFilterValue}
        setEstadoFilterValue={setEstadoFilterValue}
        setMontoPlanFilterValue={setMontoPlanFilterValue}
        nroOrdenFilterValue={nroOrdenFilterValue}
        fechaOrdenFilterValue={fechaOrdenFilterValue}
        estadoFilterValue={estadoFilterValue}
        montoPlanFilterValue={montoPlanFilterValue}
        openOpcionesOrdenamientoModal={openOpcionesOrdenamientoModal}
        onOrdenar={handleOrdenarClick}
        onRestablecerOrden={handleRestablecerOrden}
        isCobrosPorFormular={true}
      />

      <OpcionesOrdenamientoModalModal
        displayModal={displayOpcionesOrdenamientoModal}
        setDisplayModal={setDisplayOpcionesOrdenamientoModal}
        closeModal={closeOpcionesOrdenamientoModal}
        distanceToTop={distanceToTopOrdenarAvisosMantenimientoModal}
        toFilter={optionsModalTitle}
        setNroOrdenFilterValue={setNroOrdenFilterValue}
        setFechaOrdenFilterValue={setFechaOrdenFilterValue}
        setEstadoFilterValue={setEstadoFilterValue}
        setMontoPlanFilterValue={setMontoPlanFilterValue}
        nroOrdenFilterValue={nroOrdenFilterValue}
        fechaOrdenFilterValue={fechaOrdenFilterValue}
        estadoFilterValue={estadoFilterValue}
        montoPlanFilterValue={montoPlanFilterValue}
        setDisplayOrdenarAvisosMantenimientoModal={setDisplayOrdenarAvisosMantenimientoModal}
        isCobrosPorFormular={true}
      />
    </div>
  );
};

export default OTCobrosPorFormular;
